import React, {useState} from "react";
import {Box} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import styled from "@emotion/styled";

const UploadProfileImage = () => {

    const [selectedImage, setSelectedImage] = useState<File | null>(null);
    const hiddenImageInput = React.useRef<HTMLInputElement | null>(null);

    const onSelectImage = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || e.target.files.length === 0) {
            setSelectedImage(null);
            return;
        }

        setSelectedImage(e.target.files[0]);
    }

    const handleUploadImageClick = () => {
        hiddenImageInput.current?.click();
    };

    return (
        <UserUploadImageContainer>
            {
                selectedImage === null
                    ? <div className="badge">CU</div>
                    : <img className="imagePreview" width="40" height="40" alt="Profile" src={URL.createObjectURL(new Blob([selectedImage]))} />
            }

            <div className="change" onClick={handleUploadImageClick}>Ändern</div>
            <div className="text">JPG oder PNG  1MB Max.</div>
            <input
                type="file"
                ref={hiddenImageInput}
                style={{ display: 'none' }}
                accept="image/png, image/jpg"
                onChange={onSelectImage}
            />
            <Box sx={{ flexGrow: 1 }} />
            <DeleteOutlineIcon sx={{cursor: "pointer"}} className="icon" onClick={() => setSelectedImage(null)}/>
        </UserUploadImageContainer>
    )

};

export default UploadProfileImage;

const UserUploadImageContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  gap: 16px;

  .badge {
    background: #FA0;
    border-radius: 12px;
    padding: 10px;
    color: white;
    text-align: center;
    font-size: 16px;
    letter-spacing: 0.003px;
  }

  .imagePreview {
    border-radius: 12px;
    width: 40px;
    height: 40px;
  }
  
  .change {
    padding: 2px 9px 2px 9px;
    border-radius: 6px;
    background: #EBEEF4;
    color: var(--M3-black, #000);
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.02px;
    cursor: pointer;
  }
  
  .text {
    color: #9598A8;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  
  .icon {
    align-items: end;
    fill: #9598A8;
  }
`;